import WeatherLoading from "./weather-loading";

export default WeatherLoading;
